export const Container = ({ children }) => {
	return (
		<div className="!m-0 color-[#353d4a] bg-[#f7faff] w-full h-screen overflow-hidden my-2 p-3 flex flex-col justify-center items-center">
			{children}
		</div>
	);
};
